import React from "react";

export function AppBackground() {
  return (
    <div className="og-app-bg" data-testid="app-background" aria-hidden="true">
      <div className="og-app-bg__image" />
      <div className="og-app-bg__veil" />
    </div>
  );
}
